import javaHttp from '@/utils/javaHttp';
import { expiredStorage } from "@/utils/expiredStorage";
export class javaApi {
    /**
     * 批量上传图片文件
     * @param userId 用户ID
     * @param files 图片文件列表
     * @returns 上传结果
     */
    static async uploadImages(files) {
        try {
            const formData = new FormData();
            const { userId } = expiredStorage.getItem('user');
            // const userId= 'adada29999922';
            // 添加用户ID参数
            formData.append('userId', userId);
            // 添加文件参数
            if (files instanceof FileList) {
                // 如果是 FileList，转换为数组
                Array.from(files).forEach(file => {
                    formData.append('files', file);
                });
            }
            else {
                // 如果是数组，直接遍历
                files.forEach(file => {
                    formData.append('files', file);
                });
            }
            const response = await javaHttp.post('/download/uploadImagesApp', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        }
        catch (error) {
            console.error('上传图片失败:', error);
            throw error;
        }
    }
    /**
     * 获取用户图片列表
     * @param userId 用户ID
     * @returns 用户图片列表
     */
    static async getUserImages(userId) {
        try {
            const response = await javaHttp.get(`/download/getUserImages?userId=${userId}`);
            console.log('javaHttp 原始响应:', response);
            return response;
        }
        catch (error) {
            console.error('获取用户图片失败:', error);
            throw error;
        }
    }
    /**
     * 发送短信验证码
     * @param phone 手机号
     * @param userId 用户ID
     * @returns 发送结果
     */
    static async sendSmsCode(phone, userId) {
        try {
            const response = await javaHttp.post('/sms/sendCode', {
                userId,
                phone: phone // 保持 string 类型
            });
            return response;
        }
        catch (error) {
            console.error('发送验证码失败:', error);
            throw error;
        }
    }
    /**
     * 验证短信验证码
     * @param phone 手机号
     * @param smsCode 验证码
     * @param userId 用户ID
     * @returns 验证结果
     */
    static async verifySmsCode(phone, smsCode, userId) {
        try {
            const response = await javaHttp.post('/sms/verifyCode', {
                phone: phone, // 保持 string 类型
                smsCode,
                userId
            });
            return response;
        }
        catch (error) {
            console.error('验证短信验证码失败:', error);
            throw error;
        }
    }
    /**
     * 上传单图并由后端生成二维码图片（返回二维码字节）
     * @param userId 用户ID
     * @param file 原始图片文件
     * @param url 当前域名或IP（如 window.location.origin）
     * @returns 二维码二进制 Blob
     */
    static async uploadSingleAndGenerateQR(userId, file, url) {
        try {
            console.log('javaApi.uploadSingleAndGenerateQR 开始执行');
            console.log('参数:', { userId, fileName: file.name, fileSize: file.size, url });
            const formData = new FormData();
            formData.append('userId', userId);
            formData.append('file', file);
            formData.append('url', url);
            console.log('准备发送请求到 /download/uploadSingleAndGenerateQR');
            const response = await javaHttp.post('/download/uploadSingleAndQR', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                responseType: 'blob'
            });
            console.log('后端响应成功，返回 Blob');
            return response;
        }
        catch (error) {
            console.error('上传并生成二维码失败:', error);
            throw error;
        }
    }
}
export default javaApi;
